/**
 * Friendly Captcha auto-inits only on DOMContentLoaded.
 * After Barba page swaps, new .frc-captcha nodes must be attached manually.
 */
export const initFriendlyCaptcha = () => {
  const WidgetInstance = window.friendlyChallenge?.WidgetInstance;
  if (!WidgetInstance) {
    return;
  }

  document.querySelectorAll(".frc-captcha").forEach((element) => {
    if (element.dataset.attached === "1") {
      return;
    }

    new WidgetInstance(element);
    element.dataset.attached = "1";
  });
};
